
import page from '~/plugins/mixins/page';
import vragen from '~/graphql/queries/vragen';

export default {
  auth: false,
  mixins: [page],
  apollo: {
    vragen: {
      query: vragen,
    },
  },
};
